export class AppError<T extends { readonly kind: string }> extends Error {
  public static from<T extends { readonly kind: string }>(
    errorData: T,
  ): AppErrorType<T> {
    return new AppError(errorData) as AppError<T> & T;
  }

  protected constructor(errorData: T) {
    let message = errorData.kind;

    if ('message' in errorData && typeof errorData.message === 'string') {
      message = errorData.message;
    }

    super(message);

    this.name = 'AppError';

    Object.setPrototypeOf(this, AppError.prototype);

    Object.assign(this, errorData);
  }
}

export type AppErrorType<T extends { readonly kind: string }> = AppError<T> & T;
